@if (activeWidget?.widget; as config) {
  <div
    class="flex flex-column justify-content-start align-content-start align-items-stretch text-left">
    <div class="flex align-items-center gap-3">
      <app-header text="Raum" icon="fa-regular fa-map"></app-header>
      <app-context-switch [activeWidgetConfig]="config"></app-context-switch>
    </div>
    @if (config.context !== 'external') {
      <div class="mt-5">
        <app-type-dropdown
          [displayNewLayerTypeOption]="true"
          [enableEmpty]="false"
          [globalSelector]="false"
          [mode]="'all'"
          [(selection)]="selectedDataLayerType"
          (selectionChange)="setDataLayerType($event)"></app-type-dropdown>
      </div>

      @if (selectedDataLayer?.geoData; as geoDataId) {
        <app-geo-group-dropdown
          styleClass="p-0"
          [colSize]="undefined"
          headerStyleClass="mt-5"
          label=""
          header="Gruppe"
          [selection]="config.activeGroup"
          (selectionChange)="setActiveGroup($event)"
          [geoDataId]="geoDataId" />
      }
    } @else if (config.context === 'external') {
      <div class="grid">
        <app-form-field-wrapper label="durchsuchen ..." [colSize]="12">
          <input
            pInputText
            [(ngModel)]="regionSearchString"
            appDebounceInput
            [debounceMs]="300"
            (debounceInput)="searchForWegweiserRegion()" />
        </app-form-field-wrapper>
      </div>
      @if (regionSearchString.length && this.filterBySelection(regionResult)) {
        <p-divider />
        <div class="max-h-15rem p-card p-2 overflow-auto">
          @for (region of this.filterBySelection(regionResult); track $index) {
            <div
              class="flex gap-2 align-items-center surface-border"
              [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }">
              <span class="flex align-items-center gap-2">
                <i class="fa-regular fa-map"></i> {{ region.name }}
              </span>

              <button
                pButton
                (click)="selectRegion(region)"
                class="p-button-xs ml-auto"
                [rounded]="true"
                icon="fas fa-plus"></button>
            </div>
          }
        </div>
      }

      @if (
        this.filterBySelection(wegweiserStore.regionCache());
        as regionsFromCache
      ) {
        <app-header
          text="nochmal auswählen"
          icon="fas fa-info-circle"></app-header>
        @for (region of regionsFromCache; track $index) {
          <div
            class="flex gap-2 align-items-center surface-border"
            [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }">
            <span class="flex align-items-center gap-2">
              <i class="fas fa-arrow-right"></i>
              {{ region.name }}
            </span>
            <button
              pButton
              (click)="selectRegion(region)"
              class="p-button-xs ml-auto"
              [rounded]="true"
              icon="fas fa-recycle"></button>
          </div>
        }
        <p-divider />
      }

      @if (
        activeWidget?.widget?.wegweiserRequestParams?.regionIds;
        as selectedRegionIds
      ) {
        @if (selectedRegionIds.length) {
          <app-header
            text="Auswahl für diese Darstellung"
            icon="fa-regular fa-map"></app-header>
          @for (regionId of selectedRegionIds; track $index) {
            <div
              class="flex gap-2 align-items-center surface-border"
              [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }">
              <span class="flex align-items-center gap-2">
                <i class="fas fa-check-circle"></i>
                {{ wegweiserStore.getWegweiserRegionById(regionId)?.name }}
              </span>
              <button
                pButton
                (click)="unselectRegion(regionId)"
                class="p-button-xs ml-auto"
                [rounded]="true"
                icon="fas fa-trash"
                severity="danger"></button>
            </div>
          }
        }
      }
    }

    @if (availableConfig.includes('poi')) {
      <app-type-multi-select
        mode="Point"
        [disableTypes]="[config.dataLayerType]"
        [header]="{ icon: 'fas fa-location-dot', text: 'Standorte' }"
        [(ngModel)]="poiToShow"
        (ngModelChange)="savePoiSelectionToConfig($event)"
        name="poiToShow"></app-type-multi-select>
      @if (poiToShow?.length) {
        <div
          cdkDropList
          [cdkDropListData]="poiToShow"
          (cdkDropListDropped)="onDrop($event)"
          class="mt-4">
          @for (poi of poiToShow; track $index) {
            <div
              class="flex flex-column gap-2 surface-border"
              [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }"
              [cdkDragData]="poi"
              cdkDrag>
              <app-poi-type-item
                [poi]="poi"
                [expanded]="isPoiExpanded(poi._id)"
                [hasData]="!!getPoiLayer(poi._id)"
                (toggleExpanded)="togglePoi(poi._id)">
                <p-checkbox
                  poi-left
                  [binary]="true"
                  [ngModel]="true"
                  (click)="$event.stopPropagation()"
                  (ngModelChange)="removePoi(poi)" />

                <div poi-right>
                  <app-geo-group-dropdown
                    label=""
                    [selection]="poiGroupConf[poi._id] || ''"
                    [disabled]="!getPoiLayer(poi._id)"
                    (selectionChange)="savePoiGroup($event, poi._id)"
                    [geoDataId]="getPoiGeoDataByYear(config.year, poi._id)" />
                </div>

                @if (getPoiLayer(poi._id); as layer) {
                  <app-poi-list
                    poi-content
                    [dataLayer]="layer"
                    (poiClicked)="onPoiClick($event)" />
                } @else {
                  <div
                    poi-content
                    class="text-xs text-color-secondary italic p-3 border-left-2 border-orange-400 surface-50 border-round-right flex align-items-center gap-2">
                    <i class="fas fa-info-circle text-orange-400"></i>
                    <span>
                      Für das Jahr {{ config.year }} liegen keine Standorte vom
                      Typ "{{ poi.name }}" vor.
                    </span>
                  </div>
                }
              </app-poi-type-item>
            </div>
          }
        </div>
      }
    }
  </div>
}
